import { SET_LAYOUT } from '@/state/mutationTypes'
import { layouts } from '../helpers'

export const layoutStore = {
  namespaced: true,
  state: {
    layout: layouts.DEFAULT_LAYOUT
  },
  getters: {
    getLayout(state) {
      return state.layout
    }
  },
  mutations: {
    [SET_LAYOUT](state, payload) {
      state.layout = payload
    }
  },
  actions: {
    setPageLayout({ commit }, layout) {
      commit(SET_LAYOUT, layout)
    }
  }
}
